import { authTypes, loginTypes, userTypes, impersonateTypes } from './types';

const initialState = {
  isLoggedIn: false,
  errorMessage: null,
  errorMessageReset: null,
  isLoading: false,
  resultMessage: null,
  user: null,
  impersonating: false,
  // unimpersonated user
  originalUser: {},
  isPasswordSecure: false
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {

    case authTypes.RESET_ERROR: {
      return {
        ...state,
        errorMessage: null,
        errorMessageReset: null
      };
    }
    case authTypes.RESET_RESULT_MESSAGE: {
      return {
        ...state,
        resultMessage: null
      };
    }
    case authTypes.SET_PASSWORD_SECURITY: {
      return {
        ...state,
        isPasswordSecure: payload
      };
    }
    
    case loginTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoading: true
      };
    }
    case loginTypes.SUCCESS: {
      const {
        userCode,
        fullName,
        profile,
        documentNumber,
        isProvider,
        providerCode,
        electronicInvoice,
        isAdmin,
        isReadonly,
        acceptedTerms
      } = payload;
      return {
        ...state,
        isLoggedIn: true,
        errorMessage: null,
        isLoading: false,
        user: {
          userCode,
          name: fullName,
          profile,
          rut: documentNumber,
          isProvider,
          providerCode,
          electronicInvoice,
          isAdmin,
          isReadonly,
          acceptedTerms
        }
      };
    }
    case loginTypes.FAILED: {
      return {
        ...state,
        isLoggedIn: false,
        isLoading: false,
        errorMessage: payload
      };
    }
    case loginTypes.LOGOUT_SUCCESS: {
      return {
        ...state,
        ...initialState,
        errorMessage: payload && payload.length > 0 ? payload : null
      };
    }

    case userTypes.ACCEPT_TERMS_REQUEST: {
      return {
        ...state,
        isLoading: true
      };
    }
    case userTypes.ACCEPT_TERMS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        user: {
          ...state.user,
          acceptedTerms: true
        }
      };
    }
    case userTypes.ACCEPT_TERMS_FAILED: {
      return {
        ...state,
        isLoading: false
      };
    }
    case userTypes.CHANGE_PASSWORD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    }
    case userTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case userTypes.CHANGE_PASSWORD_FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
      };
    }
    case userTypes.RESET_PASSWORD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        errorMessageReset: null,
      };
    }
    case userTypes.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case userTypes.RESET_PASSWORD_FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessageReset: payload,
      };
    }

    case impersonateTypes.SUCCESS: {
      const {
        userCode,
        fullName,
        profile,
        documentNumber,
        isProvider,
        providerCode,
        electronicInvoice,
        isAdmin,
        acceptedTerms
      } = payload.user;
      return {
        ...state,
        originalUser: state.user,
        isLoggedIn: true,
        errorMessage: null,
        isLoading: false,
        impersonating: true,
        user: {
          userCode,
          name: fullName,
          profile,
          rut: documentNumber,
          isProvider,
          providerCode,
          electronicInvoice,
          isAdmin,
          isReadonly: true,
          acceptedTerms
        }
      };
    }
    case impersonateTypes.ROLLBACK_SUCCESS: {
      return{
        ...state,
        ...payload
      }
    }
    case impersonateTypes.FAILED: {
      return {
        ...state,
      };
    }

    default: {
      return state;
    }
  }
};

export default authReducer;
